import React, { useEffect, useState } from 'react'
import {
  Jumbotron,
  Button,
  Container,
  Row,
  Col,
  Carousel,
  useAccordionToggle,
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AccordionCard } from '../../accordion'
import { applicationRoles } from '../../../constants/actionTypes'
import ContactUsDialog from 'application/components/dialog/contactUsDialog'
import { IsSpecialEmployer } from 'application/helpers'
import GreenTick from 'application/images/maxxia-tick.svg'
import Tooltip from 'application/components/tooltip'
import * as E from './homeElements'
import * as C from './contentSectionElements'
import { IHomeContentSectionProps } from './homeInterfaces/IHomeContentSectionProps'
import { formatCurrency } from 'application/helpers'
import { remainingLeaseTime } from 'application/utils/utilityFunctions'
import { ReleaseCard } from '@mmsg/louie'
import { Accordion } from 'react-bootstrap'
import { ITheme } from 'application/utils/type'
import globals from 'application/constants/globals'
import { Icon as MaxxiaIcons } from 'Maxxia/icons'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Icon as RemServIcons } from 'RemServ/icons'
import { Image as RemServImage } from 'RemServ/images'
import { HomeStaticData } from './homeStaticData'

interface ITestimonialData {
  imageName: string
  headingText: string
  bodyText: string
}

const ContentSection = (props: IHomeContentSectionProps) => {
  const [showMoreBenefits, setShowMoreBenefits] = useState(true)

  const CustomToggle = (props: { eventKey: any; theme: ITheme }) => {
    const decoratedOnClick = useAccordionToggle(props.eventKey, () => null)
    return (
      <C.BenefitsToggleText
        theme={props.theme}
        onClick={decoratedOnClick}
        id="contentsection.morebenefitsaccordion"
      >
        {showMoreBenefits ? 'View more benefits ' : 'Hide benefits '}
        <img
          src={
            showMoreBenefits
              ? '/images/chevron-down.svg'
              : '/images/chevron-up.svg'
          }
        />
      </C.BenefitsToggleText>
    )
  }

  let endDate
  if (props.leaseEndDate && new Date(props.leaseEndDate) > new Date())
    endDate = remainingLeaseTime(props.leaseEndDate)

  let tooltip = (
    <span>
      {' '}
      <Tooltip
        header="Fortnightly out of pocket"
        text="The amount your current lease takes out of your take-home pay."
      />
    </span>
  )
  let releaseIcon = <img src="/images/benefit-car-icon.svg" />

  const IconTextPair = ({
    iconName,
    text,
    id,
  }: {
    iconName: string
    text: string
    id: string
  }) => {
    return (
      <Col sm className="text-center">
        <div className="benefit-icon">
          {globals.isBrandMX ? (
            <MaxxiaIcons iconType={iconName} primary id={id + '.icon'} />
          ) : (
            <RemServIcons
              iconType={iconName}
              primary
              id={id + '.icon'}
              size={3.6}
            />
          )}
        </div>
        <E.BenefitText className="mb-3" id={id + '.text'}>
          {text}
        </E.BenefitText>
      </Col>
    )
  }

  const NumberedBulletPoint = ({
    itemNumber,
    heading,
    text,
  }: {
    itemNumber: number
    heading: string
    text: string
  }) => {
    return (
      <div>
        <C.NumberedBulletPointHeadingDiv>
          <C.GreenNumberCircle theme={props.theme}>
            {itemNumber}
          </C.GreenNumberCircle>

          <C.StyledH2 theme={props.theme} className="mb-0 ml-3">
            {heading}
          </C.StyledH2>
        </C.NumberedBulletPointHeadingDiv>
        <C.IndentedP className="text-grey-a">{text}</C.IndentedP>
      </div>
    )
  }

  const Testimonials = () => {
    let items: ITestimonialData[] = HomeStaticData('TestimonialData')

    return (
      <Carousel touch={true} className="bg-white">
        {items.map((item: ITestimonialData) => (
          <Carousel.Item>
            <Row>
              <Col lg={4} sm={12}>
                <div className="testimonial-image-wrapper">
                  <div className="user-image-wrapper">
                    {globals.isBrandMX && (
                      <MaxxiaImage
                        imageName={item.imageName}
                        className="user-image"
                        alt=""
                      />
                    )}
                    {globals.isBrandRS && (
                      <RemServImage
                        imageName={item.imageName}
                        className="user-image"
                        alt=""
                      />
                    )}
                  </div>
                </div>
              </Col>
              <Col sm={8}>
                <Carousel.Caption>
                  <Row>
                    <Col sm={12}>
                      <p className="text-uppercase">{item.headingText}</p>
                      <h3>{item.bodyText}</h3>
                    </Col>
                  </Row>
                </Carousel.Caption>
              </Col>
            </Row>
          </Carousel.Item>
        ))}
      </Carousel>
    )
  }

  let showSAGovFAQ = IsSpecialEmployer('SAG') && !props.isProposalCreated

  return (
    <>
      <Jumbotron
        fluid
        className=" section"
        style={{ maxWidth: '996px', background: '#ffffff00' }}
      >
        {props.isrelease ? (
          <Container id="contentsection.releasecontainer">
            <h2 className="text-uppercase">Your current expiring lease</h2>
            <Row>
              <Col sm={8}>
                <h1 className="font-weight-bold">
                  Let’s recap the key benefits
                </h1>

                <C.TickListDiv>
                  <img src={GreenTick} alt="tick" />
                  You may have lowered your overall taxable income.
                </C.TickListDiv>
                <C.TickListDiv>
                  <img src={GreenTick} alt="tick" />
                  You may have paid less tax on your vehicle's running expenses
                  including:
                  <br />
                  - registration
                  <br />
                  - roadside assist
                  <br />
                  - insurance
                  <br />
                  - servicing
                  <br />
                  - fuel
                  <br />
                  - car washing
                  <br />- new tyres
                </C.TickListDiv>
                <C.TickListDiv>
                  <img src={GreenTick} alt="tick" />
                  Your automatic payment covered all your vehicle's regular
                  expenses - which means you never had to worry about finding
                  money for fuel, your registration or insurance.
                </C.TickListDiv>
                <C.TickListDiv>
                  <img src={GreenTick} alt="tick" />
                  Plus many more!
                </C.TickListDiv>
              </Col>
              <Col
                sm={4}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <ReleaseCard
                  formattedOutOfPocket={formatCurrency(
                    props.currentNLOutOfPocket
                  )}
                  registrationNumber={props.registrationNumber}
                  remainingTime={endDate}
                  tooltip={tooltip}
                  icon={releaseIcon}
                  theme={props.theme}
                  id="contentsection.releasecard"
                />
              </Col>
            </Row>
          </Container>
        ) : (
          //Not a re-lease
          <Container id="contentsection.nonreleasecontainer">
            <Row>
              <C.ContentSectionCol sm={6}>
                <h1 className="font-weight-bold">
                  What's novated leasing again?
                </h1>
                <p>{HomeStaticData('WhatsNLText')}</p>
                {globals.isBrandRS && props.isGov && (
                  <p>
                    For more information about a Novated Lease, please refer to
                    the Queensland Government &nbsp;
                    <C.StyledLink
                      target="_blank"
                      href="https://doc.remserv.com.au/Document/RemServ/Novated%20Leasing%20Information%20Booklet%20-%20Feb%202021.pdf"
                    >
                      Novated Lease Information Booklet.
                    </C.StyledLink>
                  </p>
                )}
              </C.ContentSectionCol>
              <Col sm={6} className="text-center">
                <E.CircleImageIcon
                  src="/images/novated-lease-icon.png"
                  alt=""
                />
              </Col>
            </Row>
          </Container>
        )}

        {showSAGovFAQ && (
          <AccordionCard
            defaultActive
            expandAccordion={false}
            title="Information on Your Options from the South Australian Government"
            className="mt-3"
            id="contentsection.sagovoptionsaccordion"
            smallerTitleText={false}
          >
            <div>
              <div>
                Under the South Australian Government's salary sacrifice
                program, you have the option of either a fully maintained lease
                that is supported and established by Maxxia based on
                instructions from you or a self-managed lease where you are
                responsible for sourcing the financier, negotiating the purchase
                and delivery of the car, managing the signing of all the
                required documentation, arranging comprehensive car insurance
                and most importantly, setting the budget (salary deductions).
              </div>
              <br />
              <div>
                With a self-managed lease, Maxxia is only responsible for
                setting up the lease in your salary packaging account, managing
                the salary deductions from your employer and making lease
                finance payments and reimbursement of expenses where funds are
                available in your account. You will be responsible for
                monitoring your account balance and budget for the ongoing
                running costs. You can contact Maxxia to make adjustments to
                your running cost budget if required.
              </div>
              <br />
              <div>
                For a fully maintained lease, the estimates provided by Maxxia
                will be based on finance arranged through one of our panel of
                financiers, and where we have commercial arrangements to provide
                novated lease finance You can download the{' '}
                <a
                  href="https://doc.maxxia.com.au/Document/Maxxia/MAXMKG_NLvsSM_ComparisonTable.pdf"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="contentsection.sagovguidelink"
                >
                  Novated Lease Options Comparison table
                </a>{' '}
                to understand the key difference in the novated leasing options
                available.
              </div>
              <br />
              <div>
                It is important to note that for a fully maintained novated
                lease, Maxxia undertakes more of the activities required to set
                up and maintain a lease. For a self-managed novated lease, you
                will be required to do all the activities required to set up and
                maintain a lease. Different interest rates, fees, charges and
                responsibilities apply to the two options. Please take the time
                to consider all of this information prior to making your
                decision on which lease option you want to choose.
              </div>
              <br />
              <div>
                <strong>
                  As always, it is recommended by the SA Government that you
                  discuss any novated lease option with your financial advisor
                  before entering into an arrangement to ensure the novated
                  lease you select is right for your individual circumstance.
                </strong>
              </div>
              <br />
              <div>
                Your consultant {props.consultantFirstName} is available to help
                you understand the key differences in the options available.{' '}
                <ContactUsDialog
                  className="link"
                  theme="link"
                  launchText="Contact your consultant for a chat"
                />
                .
              </div>
            </div>
          </AccordionCard>
        )}
      </Jumbotron>

      <Jumbotron fluid className="bg-grey-secondary section-benefits">
        <Container>
          <h1 className="font-weight-bold">
            Perks and benefits of driving with{' '}
            {globals.isBrandMX ? 'Australia’s' : 'Queensland’s'} largest novated
            leasing provider
          </h1>
          <Row className="ui-list-container">
            <IconTextPair
              iconName={globals.isBrandMX ? 'Umbrella' : 'IconTick'}
              text={
                'Get add-on insurance designed for novated leases' +
                (globals.isBrandRS ? '*' : '')
              }
              id="contentsection.benefitsinsurance"
            />
            <IconTextPair
              iconName={globals.isBrandMX ? 'BenefitDollar1' : 'IconDollar'}
              text={
                'Access our fleet discount' + (globals.isBrandRS ? '*' : '')
              }
              id="contentsection.benefitsfleetdiscount"
            />
            <IconTextPair
              iconName={globals.isBrandMX ? 'BenefitTax' : 'IconCar'}
              text={
                globals.isBrandMX
                  ? 'Lower your overall taxable income, which means you could pay less tax'
                  : 'You could lower your overall taxable income, and potentially pay less tax'
              }
              id="contentsection.benefitslowertax"
            />
            <IconTextPair
              iconName={globals.isBrandMX ? 'BenefitDollar' : 'IconPiggy'}
              text={"You don't pay GST on eligible vehicles"}
              id="contentsection.benefitssavegst"
            />
          </Row>

          <div className="accordion-benefits" id="accordion-benefits">
            <div onClick={() => setShowMoreBenefits(!showMoreBenefits)}>
              <Accordion>
                <Accordion.Collapse eventKey="0" className="expandAccordion">
                  {
                    <div>
                      <Row className="ui-list-container">
                        <IconTextPair
                          iconName={
                            globals.isBrandMX ? 'BenefitMobile' : 'IconMobile'
                          }
                          text={
                            'Get instant access to payments and claims in your ' +
                            globals.brand +
                            ' app'
                          }
                          id="contentsection.benefitsapp"
                        />
                        <IconTextPair
                          iconName={
                            globals.isBrandMX ? 'BenefitEdit' : 'IconDollar3'
                          }
                          text="Budget better and kick bill shock to the kerb"
                          id="contentsection.benefitsbudgeting"
                        />
                        <IconTextPair
                          iconName={
                            globals.isBrandMX
                              ? 'BenefitRunningCosts'
                              : 'IconCar2'
                          }
                          text="Potentially pay less tax on running costs"
                          id="contentsection.benefitsrunningcosts"
                        />
                        <IconTextPair
                          iconName={
                            globals.isBrandMX
                              ? 'BenefitRepairs'
                              : 'ScheduledMaintenance'
                          }
                          text={
                            (globals.isBrandMX ? 'S' : 'You could s') +
                            'ave on servicing and repairs' +
                            (globals.isBrandRS ? '*' : '')
                          }
                          id="contentsection.benefitsservicing"
                        />
                      </Row>
                    </div>
                  }
                </Accordion.Collapse>
                <C.BenefitsToggleParentDiv>
                  <C.BenefitsToggleHRDiv>
                    <hr></hr>
                  </C.BenefitsToggleHRDiv>

                  <C.BenefitsToggleTextDiv
                    theme={props.theme}
                    id="contentSection.benefitstoggletext"
                  >
                    <CustomToggle eventKey="0" theme={props.theme} />
                  </C.BenefitsToggleTextDiv>
                </C.BenefitsToggleParentDiv>
              </Accordion>
            </div>
          </div>
        </Container>
      </Jumbotron>
      <Jumbotron fluid className="bg-white section section-estimate-steps ">
        <Container>
          <h1 className="font-weight-bold">How to set the wheels in motion</h1>
          <NumberedBulletPoint
            itemNumber={1}
            heading={'Review your estimate and accept your lease'}
            text={
              'Want changes? Let’s make them. Remember, this is an estimate, not a final offer. Once you’re happy to press on with your chosen car, accept your lease.'
            }
          />

          <NumberedBulletPoint
            itemNumber={2}
            heading={
              'Let ' + props.consultantFirstName + ' take care of the admin'
            }
            text={
              props.consultantFirstName +
              ' will make budgeting a breeze, handle the finance application process, and liaise with your employer.'
            }
          />

          <NumberedBulletPoint
            itemNumber={3}
            heading={'Sign the dotted line'}
            text={
              'Once you’re happy with your deal, we’ll handle the paperwork.'
            }
          />

          <NumberedBulletPoint
            itemNumber={4}
            heading={'Take the wheel'}
            text={
              'In a matter of days, you could be driving home your estimated savings, budget benefits and time better spent.'
            }
          />

          <div className="text-center">
            {props.applicationRole &&
              props.applicationRole !== applicationRoles.CONSULTANT && (
                <Link to="/estimates">
                  <Button
                    className="bg-brand"
                    id="contentsection.estimateslink"
                  >
                    View my estimates
                  </Button>
                </Link>
              )}
            {props.applicationRole &&
              props.applicationRole === applicationRoles.CONSULTANT && (
                <Link
                  to="/consultant/estimates"
                  id="contentsection.consultantestimateslink"
                >
                  <Button className="bg-brand">View my estimates</Button>
                </Link>
              )}
          </div>
        </Container>
      </Jumbotron>
      <Jumbotron className="bg-white section section-testimonials">
        <h1 className="text-center">
          {globals.isBrandMX ? 'Hear' : 'Here’s'} what our customers have to say
        </h1>
        <Testimonials />
      </Jumbotron>
    </>
  )
}

export default ContentSection
